import React from 'react'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
// const isMobile = browserCheck.isMobile

export const timelineContent = [
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone red'
          contentStyle={{ background: 'var(--red-bright-1)', color: '#fff' }}
          contentArrowStyle={{ borderRight: '7px solid var(--red-bright-1)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>
            {/* <i className='icon clock' /> */}
            3:07 Uhr
          </h3>

          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Datenfluss unterbrochen: Lotsen erhalten die nötigen Infos nicht
                mehr
              </h5>
            </div>
            <div>
              {/* <h4 className='vertical-timeline-element-subtitle'>Lohnerhöhung</h4> */}
              {/* <p>Lotsen erhalten die nötigen Infos nicht mehr</p> */}
            </div>
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>3:15 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Verantwortlicher für Systemüberwachung wird aufgeboten
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone red'
          contentStyle={{ background: 'var(--red-bright-1)', color: '#fff' }}
          contentArrowStyle={{ borderRight: '7px solid  var(--red-bright-1)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>3:31 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-handshake-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Supervisor ZH und GVA ordnen «Clear the Sky» an
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>04:17/19 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-information.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Krisenstab aufgeboten
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>04:40 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-information.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Notice to airman: Flugverkehr international informiert
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>05:09 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Krisenstab Rapport
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>05:25 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Switch 02 reboot
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>05:45 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                1. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>05:46 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Switch 01 reboot
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>06:12 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Switch 02 runterfahren
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>06:30 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-information.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Mitteilung an Medien, Post auf Twitter
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                2. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>07:04 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-information.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Interne Info per Mail
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>07:05 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Evaluation der Stabilität des Netzwerks
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>07:15 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                3. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone green'
          contentStyle={{ background: 'var(--green-bright-1)', color: '#fff' }}
          contentArrowStyle={{
            borderRight: '7px solid  var(--green-bright-1)'
          }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>07:30 Uhr</h3>
          <div className='element container orange'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-network-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Bestätigung Netzwerk stabil
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>07:50 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                4. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>08:20 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                5. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>

          {/*
          <p className='additional'>
            Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
          </p>
          */}
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone green'
          contentStyle={{ background: 'var(--green-bright-1)', color: '#fff' }}
          contentArrowStyle={{
            borderRight: '7px solid  var(--green-bright-1)'
          }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>08:30 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-handshake-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Betrieb wird erst zu 50% dann zu 75% wieder aufgenommen
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-information-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Medienmitteilung erlassen
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone green'
          contentStyle={{ background: 'var(--green-bright-1)', color: '#fff' }}
          contentArrowStyle={{
            borderRight: '7px solid  var(--green-bright-1)'
          }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>09:30 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                6. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-handshake-white.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                Betrieb wieder 100% hergestellt
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>10:30 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                7. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>12:00 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                8. Krisenstab Meeting
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  },
  {
    step: (
      <>
        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large bullet' />}
        >
          <h3 className='vertical-timeline-element-title'>14:00 Uhr</h3>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-meeting.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
                9. Krisenstab Meeting
              </h5>
            </div>

            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
          <div className='element container'>
            <div className='title container'>
              <img
                className='icon category'
                src={require('../../images/icon-handshake.svg')}
              />
              <h5 className='vertical-timeline-element-subtitle'>
              Auflösung des Krisenstabs
              </h5>
            </div>
            {/* <div>
              <p>Lotsen erhalten die nötigen Infos nicht mehr</p>
            </div> */}
          </div>
        </VerticalTimelineElement>
      </>
    )
  }
  // {
  //   step: (
  //     <>
  //       <VerticalTimelineElement
  //         className='vertical-timeline-element--work'
  //         contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
  //         contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
  //         date='2011 - present'
  //         iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
  //         icon={<i className='icon dot circle large green' />}
  //       >
  //         <h3 className='vertical-timeline-element-title'>16. Juni</h3>
  //         <h4 className='vertical-timeline-element-subtitle'>Lorem ipsum</h4>
  //         <p>
  //           Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
  //           nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
  //           erat, sed diam voluptua.
  //         </p>
  //       </VerticalTimelineElement>
  //     </>
  //   )
  // }
]
